import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';
import { get } from 'lodash';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const isVehicleApplicationInSubmission = (
  vehicle: DashboardVehicle,
): boolean => {
  const status = get(vehicle, 'application.status');

  return (
    status === ChecklightSessionStatus.QUEUED_FOR_SUBMISSION ||
    status === ChecklightSessionStatus.FAILED_SUBMISSION
  );
};
